import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import {
  OPTIONS_PACKAGE_STATUS,
  PAGE_SIZE_OPTIONS,
  TagCustom
} from '../../configData'
import { getPakageHistoryPost } from '../../services/pakage-post'
import Card from '../Card'
import ModalConfirm from '../common/ModalConfirm/ModalConfirm'
import TableField from '../common/Table/TableField'
import AuthenticatedLink from '../Export/AuthenticatedLink'
import FilterForm from './FilterForm'
import openNotification from '../common/Notification/openNotification '
import Loading from '../Loading';

const ConfigPostHistory = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState('')
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    // let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      name: filters.text_search || '',
      status: filters.status || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getPakageHistoryPost(cleanedData)
      _dataSource = response?.data?.list
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },

    {
      title: 'Họ và tên',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => {
        return <div>{record?.user_info?.name}</div>
      }
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'phone_number',
      key: 'phone_number',
      width: 150,
      render: (_, record) => {
        return <div>{record?.user_info?.phone}</div>
      }
    },
    {
      title: 'TKC',
      dataIndex: 'main_account',
      key: 'main_account',
      width: 150,
    },
    {
      title: 'TKKM',
      dataIndex: 'promotion_account',
      key: 'promotion_account',
      width: 150,
    },
    {
      title: 'Thời gian',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => (
        <span>
          {record?.created_at
            ? dayjs(record.created_at).format('HH:mm:ss DD/MM/YYYY')
            : ''}
        </span>
      )
    },
    {
      title: 'Trang thái',
      dataIndex: 'status',  
      key: 'status',
      width: 150,
      // render: (_, record) => {
      //   return (
      //     <div>
      //       {OPTIONS_PACKAGE_STATUS.find((item) => item.value === record.status)
      //         ?.name || ''}
      //     </div>
      //   )
      // }
      render: (_, record) => {
        return <TagCustom arr={OPTIONS_PACKAGE_STATUS} status={record.status} />
      }
    },
    { title: 'Nội dung', dataIndex: 'description', key: 'description', width: 150 }
  ]


  useEffect(() => {
    const p = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      text_search: filters.text_search || '',
      status: filters.status || '',
      start_date:
        (filters?.date && dayjs(filters?.date[0], 'DD/MM/YYYY').valueOf()) ||
        '',
      end_date:
        (filters?.date && dayjs(filters?.date[1], 'DD/MM/YYYY').valueOf()) || ''
    }
    const cleanedData = Object.fromEntries(
      Object.entries(p).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )
    const params = new URLSearchParams({ ...cleanedData })

    setUrl(
      `${process.env.REACT_APP_API_URL}/api/v1/pakages/export?` +
        params
    )
  }, [filters])

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        ></div>

        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {hasPermission('P56.1', permissions) && (
          <AuthenticatedLink
            url={url || ''}
            filename={'Danh-sach-lich-su-goi-tin-dang-web'}
          >
            Export
          </AuthenticatedLink>
          )}
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      <ModalConfirm />
    </div>
  )
}

export default ConfigPostHistory
